import React from "react";
import "../css/QualityPolicy.css";

const QualityPolicy = () => {
  const qualityImg = "/images/f.jpeg";

  return (
    <section className="quality-policy-section">
      <div className="quality-container">
        {}
        <div className="quality-image-wrapper">
          <div className="quality-dashed-frame"></div>
          <img
            src={qualityImg}
            alt="Quality Policy"
            className="quality-main-img"
          />
        </div>

        {}
        <div className="quality-text-wrapper">
          <h2 className="quality-title">Quality Policy</h2>
          <p className="quality-intro">
            At Sahara, we take our values, vision, and mission seriously. To
            this end, we created the following framework that helps us stay
            aligned with our vision and mission.
          </p>

          <ul className="quality-bullet-list">
            <li>Adherence to a Quality Management System</li>
            <li>Sharing of Best Practices</li>
            <li>Actionable Feedback based on Stakeholder Satisfaction</li>
            <li>Surveys</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default QualityPolicy;
